import React from "react";
import { statusBadgeColors, statusLabel } from "@/lib/util";

export function StatusBadge({ status, className = "" }) {
    return (
        <span
            data-testid={`status-badge-${status}`}
            className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest border ${statusBadgeColors(status)} ${className}`}
        >
            {statusLabel(status)}
        </span>
    );
}
